import React from "react";
import { QueryInterestProfile } from "types/gql-types";
import styles from "../details.module.css";
import Heading from "./heading";
import Row from "./row";

type Interest = NonNullable<QueryInterestProfile["interest"]>;


const formatYesNoEmpty = (val: boolean | null | undefined) => {
  switch (val) {
    case true:
      return "Yes";
    case false:
      return "No";
    default:
      return "";
  }
};


const renderUnitSizes = (interest: Interest): React.ReactNode => [
  interest.unitSize || null,
  interest.unitSizeSro ? "SRO" : null,
  interest.unitSizeStudio ? "Studio" : null,
  interest.unitSize1br ? "1BR" : null,
  interest.unitSize1brDen ? "1BR_DEN" : null,
  interest.unitSize2br ? "2BR" : null,
  interest.unitSize3br ? "3BR" : null,
  interest.unitSize4br ? "4BR" : null,
  interest.unitSize5br ? "5BR" : null,
]
  .filter(Boolean)
  .join(", ");

type Props = { interest: Interest }

const EligibilityInformation: React.FC<Props> = ({ interest: fd }) => (
  <div className={styles.group}>
    <Heading text="Eligibility" />
    <Row title="# of Skips">{fd.skips ?? "0"}</Row>
    <Row title="Unit Size">{renderUnitSizes(fd)}</Row>
    <Row title="Gross Annual Income">
      {fd.householdGrossAnnualIncome && `$ ${fd.householdGrossAnnualIncome.toLocaleString()}`}
    </Row>

    <Row title="Household Size">{fd.householdCount}</Row>
    <Row title="Section 8">{formatYesNoEmpty(fd.householdHasHousingAuthorityVoucher)}</Row>
    <Row title="Other Subsidy">
      {formatYesNoEmpty(fd.householdReceivesOtherHousingAssistance)}
    </Row>
  </div>);

export default EligibilityInformation;
